import React from 'react';
import Typography from '@material-ui/core/Typography';
import LoaderGif from '../../style/Images/loader_nw.gif';

interface ViewerProps {
  loading?: boolean;
  loadingMessage?: string;
  title: string;
  url?: string;
}

interface ViewerLoaderProps {
  message: string;
}

const ViewerLoader = ({message}: ViewerLoaderProps) => {
  return (
    <div className="mt30 textCenter" style={{height: '600px', display: 'flex', alignItems: 'center'}}>
      <div>
        <span className="floatLeft w100">
          <img alt="Loading..." className="mb15" src={LoaderGif} />
        </span>
        <span className="floatLeft w100">
          <Typography variant="caption" className="w100">
            {message || 'Loading...'}
          </Typography>
        </span>
      </div>
    </div>
  )
};

const Viewer = ({loading, loadingMessage, title, url}: ViewerProps) => {
  const iFrameProps: any = {height: '600px', id: 'viewer_iframe', src: url, title, width: '100%'};
  return (
    <>
      {
        loading && loadingMessage &&
        <ViewerLoader message={loadingMessage} />
      }

      {
        !loading && !!url &&
        <iframe {...iFrameProps} />
      }
    </>
  );
};

export default Viewer;
